import { useEffect, useState } from "react";
import api from "@/lib/api";

const FIELDS_RS = [
  { k: "ragione_sociale", label: "Ragione Sociale" },
  { k: "sede", label: "Sede" },
  { k: "partita_iva", label: "Partita IVA" },
  { k: "codice_fiscale", label: "Codice Fiscale" },
  { k: "telefono", label: "Telefono" },
  { k: "email", label: "Email" },
  { k: "iban", label: "IBAN", cols: 2 },
];

const FIELDS_LR = [
  { k: "lr_cognome", label: "Cognome" },
  { k: "lr_nome", label: "Nome" },
  { k: "lr_nato_a", label: "Nato a" },
  { k: "lr_nato_il", label: "Nato il", type: "date" },
  { k: "lr_telefono", label: "Telefono" },
  { k: "lr_email", label: "Email" },
  { k: "lr_recapito", label: "Recapito" },
];

const FIELDS_SO = [
  { k: "so_nome", label: "Nome", cols: 2 },
  { k: "so_indirizzo", label: "Indirizzo", cols: 2 },
  { k: "so_cap", label: "CAP" },
  { k: "so_citta", label: "Città" },
  { k: "so_prov", label: "Prov" },
  { k: "so_telefono", label: "Telefono" },
  { k: "so_email", label: "Email", cols: 2 },
];

export default function AziendaAnagraficaPage() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.get("/azienda").then(r => setForm(r.data || {})).catch(() => setForm({}));
  }, []);

  const salva = async () => {
    setSaving(true); setMsg(null);
    try {
      await api.put("/azienda", form);
      setMsg({ type: "ok", text: "Salvato ✓" });
    } catch (e) {
      setMsg({ type: "err", text: e.response?.data?.detail || "Errore" });
    } finally { setSaving(false); }
  };

  const setField = (k, v) => setForm({ ...form, [k]: v });

  return (
    <div style={{ padding: 20, maxWidth: 900 }}>
      <h2 style={{ color: "#b8860b", fontSize: 18, marginTop: 0 }}>🏢 Anagrafica Azienda</h2>
      <p style={{ fontSize: 11, color: "#888", marginTop: -8, marginBottom: 16, fontStyle: "italic" }}>
        Dati comuni a tutte le procedure (privacy, moduli, report, contratti…).
      </p>
      <div style={{ background: "white", border: "1px solid #ccc", padding: 18, marginBottom: 14 }}>
        <h3 style={{ fontSize: 13, color: "#b8860b", borderBottom: "2px solid #ffc107", paddingBottom: 6, marginTop: 0 }}>Ragione Sociale</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {FIELDS_RS.map(f => (
            <div key={f.k} style={f.cols === 2 ? { gridColumn: "1 / span 2" } : undefined}>
              <label style={{ fontSize: 10, fontWeight: 700, color: "#666", display: "block", marginBottom: 3 }}>{f.label.toUpperCase()}</label>
              <input value={form[f.k] || ""} onChange={e => setField(f.k, e.target.value)}
                data-testid={`az-${f.k}`}
                style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12, fontFamily: f.k === "iban" ? "Consolas, monospace" : undefined }} />
            </div>
          ))}
        </div>
      </div>
      <div style={{ background: "white", border: "1px solid #ccc", padding: 18, marginBottom: 14 }}>
        <h3 style={{ fontSize: 13, color: "#b8860b", borderBottom: "2px solid #ffc107", paddingBottom: 6, marginTop: 0 }}>Legale Rappresentante</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {FIELDS_LR.map(f => (
            <div key={f.k}>
              <label style={{ fontSize: 10, fontWeight: 700, color: "#666", display: "block", marginBottom: 3 }}>{f.label.toUpperCase()}</label>
              <input value={form[f.k] || ""} onChange={e => setField(f.k, e.target.value)}
                type={f.type || "text"}
                data-testid={`az-${f.k}`}
                style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
            </div>
          ))}
        </div>
      </div>
      <div style={{ background: "white", border: "1px solid #ccc", padding: 18, marginBottom: 14 }}>
        <h3 style={{ fontSize: 13, color: "#b8860b", borderBottom: "2px solid #ffc107", paddingBottom: 6, marginTop: 0 }}>Sede Operativa</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {FIELDS_SO.map(f => (
            <div key={f.k} style={f.cols === 2 ? { gridColumn: "1 / span 2" } : undefined}>
              <label style={{ fontSize: 10, fontWeight: 700, color: "#666", display: "block", marginBottom: 3 }}>{f.label.toUpperCase()}</label>
              <input value={form[f.k] || ""} onChange={e => setField(f.k, e.target.value)}
                data-testid={`az-${f.k}`}
                style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
            </div>
          ))}
        </div>
      </div>
      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <button onClick={salva} disabled={saving} data-testid="az-save"
          style={{ padding: "8px 24px", background: "#b8860b", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          {saving ? "Salvataggio..." : "💾 Salva"}
        </button>
        {msg && <span style={{ color: msg.type === "ok" ? "#2e7d32" : "#c62828", fontSize: 12, fontWeight: 700 }}>{msg.text}</span>}
      </div>
    </div>
  );
}
